import React from 'react';
import { Row, Col, Label } from 'reactstrap';
import StatusIcon from '../../../components/StatusIcon';
import MediablockClock from '../../../components/MediablockClock';

const mediablockFields = [
    { label: 'Product Name', name: 'productName' },
    { label: 'Software Version', name: 'softwareVersion' },
    { label: 'Firmware Version', name: 'firmwareVersion' },
    { label: 'Dowser', name: 'dowser' },
    { label: 'Lamp', name: 'lamp' },
    { label: 'State', name: 'state', statusType: 'mediablockState' },
    { label: 'Capacity', name: 'capacity', type: 'number' },
    { label: 'Used Disk Space', name: 'usedDiskSpace', type: 'number' },
];

const MediablockProperties = ({ initialSettings }) => {
    const settings = initialSettings || {};

    const renderField = field => (
        <Col md={6} key={field.name}>
            <h5 className="mt-3 text-uppercase" >{field.label}</h5>
            <div style={{'color': '#ffffff80'}}>
                {field.statusType ? (
                    <StatusIcon type={field.statusType} value={settings[field.name]} showLabel />
                ) : (
                    settings[field.name] || `no ${field.name} available`
                )}
            </div>
        </Col>
    );

    return (
        <div>
            <Row>
                {mediablockFields.map(renderField)}
                <Col md={6}>
                    <h5 className="mt-3 text-uppercase" >Status</h5>
                    <div style={{'color': '#ffffff80'}}>
                        <StatusIcon type="mediablockStatus" value={settings?.status} showLabel />
                    </div>
                </Col>
            </Row>

            {/* The cronjob keeps the last known zone when the player goes offline, so gate on
                the connection the way the panel summary does - otherwise a disconnected
                mediablock shows a ticking clock. */}
            {settings.timeZone && settings.status === 'Connected' && (
                <Row className="mt-3">
                    <Col className="d-flex flex-row">
                        <Label style={{ width: '250px' }}>
                            <span className="far fa-clock fa-fw me-2 text-primary"/>
                            Date &amp; Time
                        </Label>
                        <MediablockClock
                            timeZone={settings.timeZone}
                            clockOffsetSeconds={settings.clockOffsetSeconds}
                            timeSource={settings.timeSource}
                        />
                    </Col>
                </Row>
            )}

            <Row className="mt-3">
                <Col className="d-flex flex-row align-items-center">
                    <Label style={{ width: '250px' }}>
                        <span className="fas fa-barcode fa-fw me-2 text-primary"/>
                        Serial Number
                    </Label>
                    {settings.serialNumber || 'N/A'}
                </Col>
            </Row>

            <Row className="mt-3">
                <Col className="d-flex flex-row align-items-center">
                    <Label style={{ width: '250px' }}>
                        <span className="fas fa-network-wired fa-fw me-2 text-primary"/>
                        IP Address 1
                    </Label>
                    {settings.ipAddress1 || 'N/A'}
                </Col>
            </Row>
            <Row className="mt-3">
                <Col className="d-flex flex-row align-items-center">
                    <Label style={{ width: '250px' }}>
                        <span className="fas fa-network-wired fa-fw me-2 text-primary"/>
                        IP Address 2
                    </Label>
                    {settings.ipAddress2 || 'N/A'}
                </Col>
            </Row>
        </div>
    );
};

export default MediablockProperties;
